export default "__VITE_ASSET__B_$_mHcG__";